<form [formGroup]="form" (submit)="onSubmit($event)">
  <div class="modal-body">
    <div class="form-group">
      <div class="d-flex justify-content-between align-items-center">
        <label for="from-account">From account *</label>
        <input
          placeholder="Filter accounts"
          type="text"
          class="form-control form-control-sm filter-input"
          (change)="filterFromAccount = $event.target.value"
        />
      </div>
      <select
        class="form-control"
        id="from-account"
        [formControl]="fromAccountId"
        (change)="onSelectFromAccountId()"
      >
        <option value="" selected="selected">Choose account</option>
        <option *ngFor="let account of fromAccounts" [value]="account.id">
          {{ account.displayName }} ({{ account.id }})
        </option>
      </select>
    </div>

    <div class="form-group">
      <label for="template-id"
        >Templates to copy * (press CTRL/CMD to select multiple)</label
      >
      <select
        multiple
        class="form-control"
        id="template-id"
        [formControl]="templateIds"
        (change)="onSelectTemplateId()"
      >
        <option *ngFor="let template of sortedTemplates" [value]="template.id">
          {{ template.name }}
        </option>
      </select>
    </div>

    <div class="form-group">
      <div class="d-flex justify-content-between align-items-center">
        <label for="to-account">To account *</label>
        <input
          placeholder="Filter accounts"
          type="text"
          class="form-control form-control-sm filter-input"
          (change)="filterToAccount = $event.target.value"
        />
      </div>
      <select class="form-control" id="to-account" [formControl]="toAccountId">
        <option value="" selected="selected">Choose account</option>
        <option *ngFor="let account of toAccounts" [value]="account.id">
          {{ account.displayName }} ({{ account.id }})
        </option>
      </select>
    </div>
  </div>

  <div class="modal-footer">
    <ng-content></ng-content>
    <button
      type="button"
      type="submit"
      class="btn btn-success"
      [disabled]="form.invalid"
    >
      <i class="fas fa-copy"></i> Copy
    </button>
  </div>
</form>
